<h2 class="title mt-0 mb-3.5 lg:mb-4">
  {{ 'wl.anz.home_page.featured_partners.title' | translate }}
</h2>

<div class="partners">
  <div class="m-auto" *ngIf="isLoading$ | async">
    <rd-shared-spinner></rd-shared-spinner>
  </div>
  <ng-container *ngIf="!(isLoading$ | async)">
    <div class="partner flex flex-col" *ngFor="let partner of partners">
      <div class="image-container rounded-md mb-5 justify-center">
        <img
          class="partner-image w-auto max-w-full"
          *ngIf="partner.imageUrl"
          [src]="partner.imageUrl"
          alt="" />
        <div
          class="partner-image loading mb-5 w-full"
          *ngIf="!partner.imageUrl"></div>
      </div>
      <h3 class="heading mt-0 mb-1.5">{{ partner.headingKey }}</h3>
      <p class="description mt-0 mb-5">{{ partner.descriptionKey }}</p>
      <div class="get-started mt-auto mb-10 lg:mb-0">
        <a
          class="get-started-link focus-link"
          [routerLink]="partner.redirectUrl[0]"
          [queryParams]="partner.redirectUrl[1] || {}"
          [attr.aria-label]="partner.ariaLabel">
          {{ partner.linkKey | translate }}
        </a>
      </div>
    </div>
  </ng-container>
</div>
